




































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  EightExpertAssessmentData, emptyAssessment, getEntrustList, closeAssessment
} from '@/api/eighthHeritage/expertAssessment'
import Element from 'element-ui'
//import ViewLink from '@/components/viewLink.vue'
import singleFile from '@/components/upload/singleFile.vue'
import { AttachInfo } from '@/api/common/attach'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: { ViewDialog, singleFile }
})
export default class EightExpertAssessmentView extends Vue {
  public name = 'EightExpertAssessmentView'
  public expandNames = ['info', 'list']
  public showDialog: boolean = false

  public loading: boolean = false
  public refreshAfterClose: boolean = false
  public expertAllocateId: number = 0
  public form: EightExpertAssessmentData = Object.assign({}, emptyAssessment)
  public list: EightExpertAssessmentData[] = []
  public $refs!: {
    formData: Element.Form
  }
  get filterSource(): any {
    let fs: any = []
    let types: number[] = []
    this.list.forEach((item: EightExpertAssessmentData, i: number) => {
      if (types.indexOf(item.StatusText) < 0) {
        fs.push({ text: item.StatusText, value: item.StatusText })
        types.push(item.StatusText)
      }
    })
    return fs
  }
  public filterMethod(value: string, row: EightExpertAssessmentData): boolean {
    return row.StatusText === value
  }
  public open() {
    this.refreshAfterClose = false
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    if (this.refreshAfterClose) {
      window.eventBus.$emit('viewEightExpertAssessment_CallBack')
    }
  }
  public fetchData(id: number) {
    this.loading = true
    getEntrustList(id).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data
        if (data.length > 0) {
          this.form.UnitId = data[0].UnitId
          this.form.UnitName = data[0].UnitName
        }
      }
      this.loading = false
    })
  }
  public created() { }
  public mounted() {
    window.eventBus.$on('viewEightExpertAssessment', (id: number) => {
      this.expertAllocateId = id
      this.fetchData(id)
      this.open()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewEightExpertAssessment')
  }
  public doClose(index: number) {
    var item: EightExpertAssessmentData = this.list[index]
    this.$confirm('确定要关闭该委托吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        closeAssessment(item.Id).then(() => {
          this.$message({ type: 'success', message: '已关闭委托' })
          this.fetchData(this.expertAllocateId)
          this.refreshAfterClose = true
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
  }
}
